import { Layout } from './components/Layout';
import { AmplifyUserProvider } from './context/AmplifyUserProvider';
import { Router } from './router';

export function App() {
  return (
    <AmplifyUserProvider>
      <Layout>
        <Router />
      </Layout>
    </AmplifyUserProvider>
  );
}

App.displayName = 'LabelPerfApp';
